import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'Inter', sans-serif;

  h2.title {
    text-align: left !important;
    padding: 8px 0;
    font-family: 'Inter', sans-serif;
  }
`;
